import { createWebHashHistory, createRouter } from 'vue-router';
import LayoutDefault from '@/components/layouts/LayoutDefault';
import AppView from '@/App';
import IndexView from '@/views/Index';
// Dashboard
import LayoutDashboard from '@/components/layouts/LayoutDashboard';
// Atendimento
import LayoutAtendimento from '@/components/layouts/LayoutAtendimento';
import TriagemView from '@/components/atendimento/Triagem';
import AtenderView from '@/components/atendimento/Atender';
import PainelView from '@/components/atendimento/Painel';

// import DashboardView from '@/views/Dashboard';
import AnaliticoStatusTipo from '@/components/dashboard/AnaliticoStatusTipo';
import ChartExamples from '@/components/dashboard/ChartExamples';
// Repositorio BI
import LayoutRepositorio from '@/components/layouts/LayoutRepositorio';
import RepoBiView from '@/components/repositoriobi/RepoBI';
// Infraestrutura
import LayoutInfra from '@/components/layouts/LayoutInfra';
import GateWayView from '@/components/infraestrutura/WSGateway';
import MonitorView from '@/components/infraestrutura/Monitor';
import DockerView from '@/components/infraestrutura/Docker';
import RecursosView from '@/components/infraestrutura/ControleRecursos';
import RecursosLocalUsoView from '@/components/infraestrutura/recursos/LocalUso';
import RecursosEquipamentosView from '@/components/infraestrutura/recursos/Equipamentos';
import RecursosDispositivosView from '@/components/infraestrutura/recursos/Dispositivos';
import RecursosStatusDispositivosView from '@/components/infraestrutura/recursos/StatusDispositivo';
import RecursosCirculacaoView from '@/components/infraestrutura/recursos/Circulacao';
// Catracas
import LayoutCatracas from '@/components/layouts/LayoutCatracas';
import IDSecureDevices from '@/components/IDSecure/Devices';
import IDSecureVisitantes from '@/components/IDSecure/Visitantes';
import IDSecureSolicitacao from '@/components/IDSecure/Solicitacoes';
import IDSecureParamAluno from '@/components/IDSecure/ParamStatusMatricula';
//Moodle UNDB
import LayoutMoodleUNDB from '@/components/layouts/LayoutMoodleUNDB';
import IntegraMoodleUndbAnalitico from '@/components/MoodleUNDB/AnaliticoIntegracao.vue'
import ResetPaswordMoodleUndb from '@/components/MoodleUNDB/ResetPasswordForm.vue'
import LogsMoodleUndb from '@/components/MoodleUNDB/LogsMoodleUndbClassroom.vue'
import LogsResetPasswordMoodleUndb from '@/components/MoodleUNDB/LogsResetPasswordMoodleUndbClassroom.vue'
//Moodle UNDBPos
import LayoutMoodleUNDBPos from '@/components/layouts/LayoutMoodleUNDBPos';
import ResetPaswordMoodleUndbPos from '@/components/MoodleUNDB/ResetPasswordFormPos.vue'
// RM
import LayoutRM from '@/components/layouts/LayoutRM';
import LinksInstitucionais from '@/components/rm/LinksInstitucionais';
import AtualizaFotoAluno from '@/components/rm/AtualizaFotoAluno';
import CadernoConcluintes from '@/components/rm/CadernoConcluintes';
import CadernoFormando from '@/components/rm/CadernoFormando';
import Enturmar from '@/components/rm/Enturmar';
import GetInfoAluno from '@/components/rm/GetInfoAluno';
import ProUniComplementar from '@/components/rm/ProUni50';
import SetDataLancamento from '@/components/rm/SetDataLancamento';
import SetMigracaoBolsas from '@/components/rm/SetMigracaoBolsas';
import AtualizaParcelaInicial from '@/components/rm/AtualizaParcelaInicial.vue';
import SetNFRejeitada from '@/components/rm/SetNFRejeitada';
// import GetUserRM from '@/components/rm/GetUserRM';
// AgendaLabs
import LayoutAgendaLabs from '@/components/layouts/LayoutAgendaLabs';
import AgendaLabsCalendar from '@/components/agenda/Calendar';
import AgendaEspacosView from '@/components/agenda/espaco/Espaco';
// IDSecure
import LogVisitanteView from '@/components/IDSecure/LogVisitante';
// Wiki
import LayoutWiki from '@/components/layouts/LayoutWiki';
import WikiBase from '@/components/wiki/Wikis';
import WikiItem from '@/components/wiki/WikiItem';
// CheckListDB
import LayoutCheckListDBView from '@/components/layouts/LayoutCheckListDB';
import AlunoView from '@/components/checklistdb/Aluno';
import ListaView from '@/components/checklistdb/Lista';
import MaterialView from '@/components/checklistdb/Material';
import DevidosView from '@/components/checklistdb/Devidos';
// RH
import LayoutRH from '@/components/layouts/LayoutRH';
import Questionarios from '@/components/rh/Questionarios.vue';
import PeriodoQuestionario from '@/components/rh/PeriodoQuestionario.vue';
import Avaliacao from '@/components/rh/Avaliar.vue';
import Colaboradores from '@/components/rh/Colaboradores.vue';
import Mentorias from '@/components/rh/Mentorias.vue';
import AvalTempoCasa from '@/components/rh/AvaliacaoNovosColabs/AvaliacaoTempoCasa';
// Else Views
import LoginView from '@/views/Login';
import NotFoundView from '@/views/NotFound';
import store from '@/store/store';
import perm from '@/pugins/permissions';

const transitionEffect = 'fade';

const homePages = {
  path: '/',
  component: LayoutDefault,
  name: 'index',
  redirect: '/gdb',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
  },
  children: [
    {
      path: 'gdb',
      name: 'inicio',
      component: IndexView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Intranet',
        title:'Página Inicial',
        subtitle: 'Grupo Dom Bosco',
        has_perm: () => perm.acesso_livre()
      }
    },
  ]
}
const infraestruturaPages = {
  path: '/infraestrutura/',
  component: LayoutInfra,
  name: 'infraestrutura',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Infraestrutura',
    title:'Início',
    subtitle: 'Recursos técnicos',
    has_perm: () => perm.is_cit() ||
                    perm.has_perm('view_monitorservico') ||
                    perm.has_perm('can_gerenciar_containers')
  },
  children: [
    {
      path: 'monitor',
      name: 'monitors',
      component: MonitorView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Infraestrutura',
        title: 'Monitor',
        subtitle: 'Monitor de serviços',
        has_perm: () => perm.has_perm('view_monitorservico')
      },
    },
    {
      path: 'docker',
      name: 'dockers',
      component: DockerView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Infraestrutura',
        title: 'Docker',
        subtitle: 'Containers e Images',
        has_perm: () => perm.has_perm('can_gerenciar_containers')
      },
    },
    {
      path: 'gateway',
      name: 'gateway',
      component: GateWayView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Infraestrutura',
        title: 'Gateway',
        subtitle: 'Websocket de Monitor de Processos',
        has_perm: () => perm.is_cit()
      }
    },
    {
      path: 'recursos',
      name: 'recursos',
      component: RecursosView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Infraestrutura',
        title: 'Recursos',
        subtitle: 'Controle de uso de dispositivos',
        has_perm: () => perm.has_perm('view_circulacao', false) ||
                        perm.has_perm('view_dispositivo', false) ||
                        perm.has_perm('view_equipamento', false) ||
                        perm.has_perm('view_localuso', false) ||
                        perm.has_perm('view_statusdispositivo', false)
      },
      children: [
        {
          path: 'locais',
          name: 'recursos-locais',
          component: RecursosLocalUsoView,
          meta: {
            transition: transitionEffect,
            requiredAuth: true,
            groupName: 'Infraestrutura',
            title: 'Locais',
            subtitle: 'Locais de uso de dispositivos',
            has_perm: () => perm.has_perm('view_localuso', false)
          },
        },    
        {
          path: 'equipamentos',
          name: 'recursos-equipamentos',
          component: RecursosEquipamentosView,
          meta: {
            transition: transitionEffect,
            requiredAuth: true,
            groupName: 'Infraestrutura',
            title: 'Equipamentos',
            subtitle: 'Equipamentos de uso',
            has_perm: () => perm.has_perm('view_equipamento', false)
          },
        },    
        {
          path: 'dispositivos',
          name: 'recursos-dispositivos',
          component: RecursosDispositivosView,
          meta: {
            transition: transitionEffect,
            requiredAuth: true,
            groupName: 'Infraestrutura',
            title: 'Dispositivos',
            subtitle: 'Identificação de dispositivos',
            has_perm: () => perm.has_perm('view_dispositivo', false)
          },
        },    
        {
          path: 'status-dispositivos',
          name: 'recursos-status-dispositivos',
          component: RecursosStatusDispositivosView,
          meta: {
            transition: transitionEffect,
            requiredAuth: true,
            groupName: 'Infraestrutura',
            title: 'Status Dispositivos',
            subtitle: 'Status de dispositivos no inventário',
            has_perm: () => perm.has_perm('view_statusdispositivo', false)
          },
        },    
        {
          path: 'circulacao',
          name: 'recursos-circulacao',
          component: RecursosCirculacaoView,
          meta: {
            transition: transitionEffect,
            requiredAuth: true,
            groupName: 'Infraestrutura',
            title: 'Circulação',
            subtitle: 'Dispositivos em circulação',
            has_perm: () => perm.has_perm('view_circulacao', false)
          },
        },    
      ]
    },
  ]
}
const agendaLabsPages = {
  path: '/agendalabs/',
  component: LayoutAgendaLabs,
  name: 'agendalabs',
  redirect: '/agendalabs/reservas/',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Agenda Labs',
    has_perm: () => true
  },
  children: [
    {
      path: 'reservas/',
      name: 'agenda-reservas',
      component: AgendaLabsCalendar,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Agenda Labs',
        title: 'Agendamentos',
        subtitle: 'Sistema de Reserva de Espaços',
        has_perm: () => perm.pode_acessar_agendalabs()
      }
    },
    {
      path: 'espacos/',
      name: 'agenda-espacos',
      component: AgendaEspacosView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Agenda Labs',
        title: 'Espaços',
        subtitle: 'Gestão de Espaços',
        has_perm: () => perm.pode_gerenciar_espacos()
      }
    },
  ]
}
const atendimentoPages = {
  path: '/atendimentos/',
  component: LayoutAtendimento,
  name: 'atendimentos',
  redirect: '/atendimentos/atende/',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Atendimento',
    has_perm: () => true
  },
  children: [
    {
      path: 'atende/',
      name: 'atendimentos-atende',
      component: AtenderView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Atendimento',
        title: 'Atender',
        subtitle: 'Área de Atendimento',
        has_perm: () => perm.is_atendente()
      }
    },
    {
      path: 'triagem/',
      name: 'atendimentos-triagem',
      component: TriagemView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Atendimento',
        title: 'Triagem',
        subtitle: 'Triagem de Senhas de atendimento',
        has_perm: () => perm.is_atendente()
      }
    },
  ]
}
const checkListDBPages = {
  path: '/checklist-db/',
  component: LayoutCheckListDBView,
  name: 'checklist-db',
  redirect: '/checklist-db/aluno',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Checklist DB',
    title:'',
    subtitle: '',
    has_perm: () => true
  },
  children: [
    {
      path: 'aluno',
      name: 'checklist-db-aluno',
      component: AlunoView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Checklist DB',
        title: 'Recebimento de Materiais',
        subtitle: 'Pesquisa',
        has_perm: () => perm.pode_receber_material_checklistdb() ||
                        perm.pode_entregar_material_checklistdb() ||
                        perm.pode_criar_listas_checklistdb() ||
                        perm.pode_atualizar_financeiro_checklistdb()
      }
    },
    {
      path: 'listas',
      name: 'checklist-db-listas',
      component: ListaView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Checklist DB',
        title: 'Listas',
        subtitle: 'Gerenciamento de Listas de Materiais',
        has_perm: () => perm.pode_criar_listas_checklistdb()
      }
    },
    {
      path: 'materiais',
      name: 'checklist-db-materiais',
      component: MaterialView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Checklist DB',
        title: 'Materiais',
        subtitle: 'Gerenciamento de Materiais',
        has_perm: () => perm.pode_gerenciar_checklistdb()
      }
    },
    {
      path: 'financeiro',
      name: 'checklist-db-devidos-financeiro',
      component: DevidosView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Checklist DB',
        title: 'Devidos Financeiro',
        subtitle: 'Lista de valores devidos',
        has_perm: () => perm.pode_atualizar_financeiro_checklistdb()
      }
    },
  ]
}
const catracasPages = {
  path: '/catracas/',
  component: LayoutCatracas,
  name: 'catracas',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Catracas',
    title: 'Acessos e Gerenciamento',
    subtitle: 'Sistema de acesso às catracas',
    has_perm: () => perm.has_group('RECURSO_INFRA_S') ||
              perm.pode_cadastrar_idsecure() ||
              perm.pode_alterar_parametros_alunos()
  },
  children: [
    {
      path: 'dispositivos',
      name: 'catracas-dispositivos',
      component: IDSecureDevices,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Catracas',
        title: 'Dispositivos',
        subtitle: 'Gerenciamento',
        has_perm: () => perm.has_group('RECURSO_INFRA_S')
      }
    },
    {
      path: 'visitantes',
      name: 'catracas-visitantes',
      component: IDSecureVisitantes,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Catracas',
        title: 'Cadastro Visitantes',
        subtitle: 'Gerenciamento',
        has_perm: () => perm.pode_cadastrar_idsecure()
      }
    },
    {
      path: 'solicitacao',
      name: 'catracas-solicitacao',
      component: IDSecureSolicitacao,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Catracas',
        title: 'Solicitação de Cadastro Visitantes',
        subtitle: 'Gerenciamento',
        has_perm: () => !perm.acesso_livre() // TODO: Alterar permissão, suspenso temporariamente (perm negada)
      }
    },
    {
      path: 'parametrizacao-aluno',
      name: 'catracas-parametros-alunos',
      component: IDSecureParamAluno,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Catracas',
        title: 'Parametrização de Integração de Status de Matrícula',
        subtitle: '',
        has_perm: () => perm.pode_alterar_parametros_alunos() // TODO: Alterar permissão
      }
    },
    {
      path: 'log-visitante/:idDevice?',
      name: 'logvisitante',
      component: LogVisitanteView,
      props: true,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Catracas',
        title: 'Log Visitante',
        subtitle: '',
        has_perm: () =>perm.pode_ver_logvisitante() // TODO: Alterar permissão
      }
    },
  ]
}
const repositorioBIPages = {
  path: '/bi/',
  component: LayoutRepositorio,
  name: 'bi',
  redirect: '/bi/repositorio/',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Fonte de dados',
    title:'Repositório',
    subtitle: 'Repositório de dados',
    has_perm: () => perm.has_bis()
  },
  children: [
    {
      path: 'repositorio/',
      name: 'bi-repositorio',
      component: RepoBiView,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Fonte de dados',
        title: 'Repositório',
        subtitle: 'Repositório de dados',
        has_perm: () => perm.has_bis()
      }
    },
  ]
}
const dashboardPages = {
  path: '/dashboard/',
  component: LayoutDashboard,
  name: 'dashboard',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Dashboard',
    title:'',
    subtitle: 'Gráficos',
    has_perm: () => perm.pode_visualizar_dashboard()
  },
  children: [
    {
      path: 'analitico/',
      name: 'dashboard-analitico',
      component: AnaliticoStatusTipo,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Dashboard',
        title: 'Analítico Status Tipo',
        subtitle: 'Gráficos',
        has_perm: () => perm.pode_visualizar_dashboard()
      }
    },
    {
      path: 'exemplos/',
      name: 'dashboard-exemplos',
      component: ChartExamples,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Dashboard',
        title: 'Exemplos',
        subtitle: 'Gráficos',
        has_perm: () => perm.pode_visualizar_dashboard()
      }
    },
  ]
}
const moodlePages = {
  path: '/moodle-undb/',
  component: LayoutMoodleUNDB,
  name: 'moodle-undb',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'UNDBClassroom',
    title: 'Integrações',
    subtitle: 'Ambiente Nuvem',
    has_perm: () => perm.has_perm('can_integrate_undbclassroom')
                  || perm.has_perm('view_integracaoclassroom')
                  || perm.has_perm('can_resetpassword_undbclassroom')
                  || perm.has_perm('view_logresetpasswordmoodleundb')
  },
  children: [
    {
      path: 'analitico/',
      name: 'moodle-undb-analitico',
      component: IntegraMoodleUndbAnalitico,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'UNDBClassroom',
        title: 'Integrações',
        subtitle: 'Analítico',
        has_perm: () => perm.has_perm('can_integrate_undbclassroom')
      },
    },
    {
      path: 'logs-integracoes/',
      name: 'moodle-undb-logs-integracoes',
      component: LogsMoodleUndb,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'UNDBClassroom',
        title: 'Logs',
        subtitle: 'Logs de Integrações',
        has_perm: () => perm.has_perm('view_integracaoclassroom')
      }
    },
    {
      path: 'reset-password/',
      name: 'moodle-undb-reset-password',
      component: ResetPaswordMoodleUndb,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'UNDBClassroom',
        title: 'Redefinição de Senha',
        subtitle: '',
        has_perm: () => perm.has_perm('can_resetpassword_undbclassroom')
      }
    },
    {
      path: 'logs-reset-password',
      name: 'moodle-undb-log-reset-password',
      component: LogsResetPasswordMoodleUndb,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'UNDBClassroom',
        title: 'Log Senhas',
        subtitle: 'Logs de Redefinição de Senhas',
        has_perm: () => perm.has_perm('view_logresetpasswordmoodleundb')
      }
    },
  ]
}
const moodlePagesPos = {
  path: '/moodle-undb-pos/',
  component: LayoutMoodleUNDBPos,
  name: 'moodle-undb-pos',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'UNDB Pós',
    title: 'Integrações',
    subtitle: 'Ambiente Nuvem',
    has_perm: () => perm.has_perm('can_resetpassword_undbpos')
  },
  children: [
    {
      path: 'logs-pos-integracoes/',
      name: 'moodle-undb-pos-logs-integracoes',
      component: LogsMoodleUndb,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Logs Integração Pós',
        title: 'Logs',
        subtitle: 'Logs de Integrações',
        has_perm: () => perm.has_perm('view_integracaoclassroom')
      }
    },
    {
      path: 'reset-password-pos/',
      name: 'moodle-undb-pos-reset-password',
      component: ResetPaswordMoodleUndbPos,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Redefinição de Senha Pós',
        title: 'Redefinição de Senha',
        subtitle: '',
        has_perm: () => perm.has_perm('can_resetpassword_undbpos')
      }
    },
    {
      path: 'logs-pos-reset-password',
      name: 'moodle-undb-pos-log-reset-password',
      component: LogsResetPasswordMoodleUndb,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Logs de redefinição de senhas Pós',
        title: 'Log Senhas',
        subtitle: 'Logs de Redefinição de Senhas',
        has_perm: () => perm.has_perm('view_logresetpasswordmoodleundb')
      }
    },
  ]
}
const rmPages = {
  path: '/rm/',
  component: LayoutRM,
  name: 'rm',
  // redirect: '/rm/recursos/',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'RM',
    title:'RM Integrações',
    subtitle: 'Apps de integrações do RM',
    has_perm: () => perm.acesso_livre()
  },
  children: [
    {
      path: 'links',
      name: 'rm-links',
      component: LinksInstitucionais,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Links Institucionais',
        subtitle: 'Links',
        has_perm: () => perm.acesso_livre()
      }
    },
    {
      path: 'caderno-formandos',
      name: 'rm-caderno-formandos',
      component: CadernoFormando,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Caderno de Formandos',
        subtitle: 'Graduação',
        has_perm: () => perm.pode_acessar_caderno_formandos()
      }
    },
    {
      path: 'caderno-concluintes',
      name: 'rm-caderno-concluintes',
      component: CadernoConcluintes,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Caderno de Concluintes',
        subtitle: 'Pós Graduação',
        has_perm: () => perm.pode_acessar_caderno_concluintes()
      }
    },
    {
      path: 'ativa-alunos',
      name: 'rm-ativa-alunos',
      component: GetInfoAluno,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Ativação de Alunos',
        subtitle: '',
        has_perm: () => perm.pode_ativar_usuarios_alunos()
      }
    },
    {
      path: 'foto-alunos',
      name: 'rm-foto-alunos',
      component: AtualizaFotoAluno,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Atualização de fotos',
        subtitle: '',
        has_perm: () => perm.pode_atualizar_foto_alunos()
      }
    },
    {
      path: 'enturmar',
      name: 'rm-enturmar',
      component: Enturmar,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Enturmação de Alunos',
        subtitle: 'Graduação',
        has_perm: () => perm.pode_enturmar_alunos()
      }
    },
    {
      path: 'migracao-bolsas',
      name: 'rm-migracao-bolsas',
      component: SetMigracaoBolsas,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Migração de Bolsas Graduação UNDB',
        subtitle: '',
        has_perm: () => perm.pode_migrar_bolsas()
      }
    },
    {
      path: 'atualiza-parcela',
      name: 'rm-atualiza-parcela',
      component: AtualizaParcelaInicial,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Atualiza Parcela Inicial UNDB',
        subtitle: '',
        has_perm: () => perm.pode_atualizar_parcela_inicial()
      }
    },
    {
      path: 'atualiza-data-lancamento',
      name: 'rm-atualizar-data-lancamentos',
      component: SetDataLancamento,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Atualização de Datas de Lançamentos',
        subtitle: '',
        has_perm: () => perm.pode_atualizar_data_lancamento()
      }
    },
    {
      path: 'atualiza-nf-rejeitada',
      name: 'rm-atualizar-nf-rejeitada',
      component: SetNFRejeitada,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Atualização de Status de NF',
        subtitle: '',
        has_perm: () => perm.pode_atualizar_nfe_rejeitada()
      }
    },
    {
      path: 'prouni-complementar',
      name: 'rm-prouni-complementar',
      component: ProUniComplementar,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'RM',
        title: 'Atualização de campo complementar de ProUni',
        subtitle: '',
        has_perm: () => perm.pode_atualizar_campo_prouni()
      }
    },
  ]
}
const wikiPages = {
  path: '/wiki/',
  component: LayoutWiki,
  name: 'wiki',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Wiki',
    title:'Documentação',
    subtitle: 'Knowledge Base',
    has_perm: () => perm.has_perm('view_wiki')
  },
  children: [
    {
      path: 'base/',
      name: 'wiki-base',
      component: WikiBase,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Wiki',
        title:'Documentação',
        subtitle: 'Knowledge Base',
        has_perm: () => perm.has_perm('view_wiki')
      }
    },
    {
      path: ':idWiki',
      name: 'wiki-item',
      props: true,
      component: WikiItem,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Wiki',
        title:'Documento',
        subtitle: 'Knowledge Base',
        has_perm: () => perm.has_perm('view_wiki')
      }
    },
  ]
}
const rhPages = {
  path: '/rh/',
  component: LayoutRH,
  name: 'rh',
  meta: {
    transition: transitionEffect,
    requiredAuth: true,
    groupName: 'Gente e Gestão',
    title: 'Avaliação',
    subtitle: '',
    has_perm: () => perm.eh_gestor_rh() ||
                    perm.eh_lider_avaliador() ||
                    perm.has_perm('can_acessar_avaliacao_tempo_casa', false)
  },
  children: [
    {
      path: 'questionarios/',
      name: 'rh-aval-questionarios',
      component: Questionarios,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Questionários',
        subtitle: '',
        has_perm: () => perm.eh_gestor_rh() && false
      }
    },
    {
      path: 'periodos/',
      name: 'rh-aval-periodos',
      component: PeriodoQuestionario,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Períodos',
        subtitle: '',
        has_perm: () => perm.eh_gestor_rh() && false
      }
    },
    {
      path: 'avaliacoes/',
      name: 'rh-aval-avaliacoes',
      component: Avaliacao,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Avaliações',
        subtitle: '',
        has_perm: () => (perm.eh_gestor_rh() || perm.eh_lider_avaliador()) && false
      }
    },
    {
      path: 'colaboradores/',
      name: 'rh-aval-colaboradores',
      component: Colaboradores,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Colaboradores',
        subtitle: '',
        has_perm: () => perm.eh_gestor_rh() && false
      }
    },
    {
      path: 'mentorias/',
      name: 'rh-aval-mentorias',
      component: Mentorias,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Mentorias',
        subtitle: '',
        has_perm: () => perm.eh_gestor_rh() && false
      }
    },
    {
      path: 'aval-tempo-casa/',
      name: 'rh-aval-tempo-casa',
      component: AvalTempoCasa,
      meta: {
        transition: transitionEffect,
        requiredAuth: true,
        groupName: 'Gente e Gestão',
        title: 'Satisfação do Colaborador',
        subtitle: '',
        has_perm: () => perm.has_perm('can_acessar_avaliacao_tempo_casa', false)
      }
    },
  ]
}
const elsePages = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      transition: transitionEffect,
      requiredAuth: false,
      groupName: 'Acesso',
      title: 'Login',
      subtitle: 'Acesso ao Sistema',
      has_perm: false
    }
  },
  {
    path: '/atendimentos/painel-app',
    name: 'atendimentos-painel-app',
    component: PainelView,
    meta: {
      transition: null,
      requiredAuth: false,
      groupName: 'Atendimentos',
      title: 'Painel',
      subtitle: 'Painel de atendimentos',
      has_perm: () => true //perm.is_atendente()
    }
  },
  {
    path: "/not-found",
    name: "page-not-found",
    component: NotFoundView,
    meta: {
      transition: transitionEffect,
      requiredAuth: false,
      groupName: 'Error',
      title: 'Página não encontrada',
      subtitle: 'Página não encontrada',
      has_perm: true
    }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: '/not-found'
  }
]
const routes = [
  {
    path: '/',
    name: 'app',
    component: AppView,
    redirect: '/gdb/', // Definir Página Inicial
    meta:{
      transition: transitionEffect,
      requiredAuth: true,
      title: 'Início',
    },
    children: [
      homePages,
      atendimentoPages,
      infraestruturaPages,
      agendaLabsPages,
      checkListDBPages,
      catracasPages,
      dashboardPages,
      moodlePages,
      moodlePagesPos,
      repositorioBIPages,
      rhPages,
      rmPages,
      wikiPages,
    ]
  },
  ...elsePages
]
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!store.getters.isAuthenticated
  // se a rota de "to" requer autenticação
  if (to.meta.requiredAuth){
    // se usuário não está autenticado
    if (!isAuthenticated) {
      next({ name: 'login' })
      return
    }
  }
  // Se usuário tiver autenticado e tentar acessar a rota de login, redirecionar para home
  if (isAuthenticated && to.name === 'login'){
    next({name:'index'})
    return
  }
  next()
})
// router.afterEach(() => {
//   // Remove initial loading
//   const appLoading = document.getElementById('loading-bg')
//     if (appLoading) {
//         appLoading.style.display = "none";
//     }
// })
export default router